import { render } from "./BindDigitalWallet.vue?vue&type=template&id=2150c1fe&scoped=true"
import script from "./BindDigitalWallet.vue?vue&type=script&lang=js"
export * from "./BindDigitalWallet.vue?vue&type=script&lang=js"

import "./BindDigitalWallet.vue?vue&type=style&index=0&id=2150c1fe&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2150c1fe"]])

export default __exports__